import { Box } from "@mui/material";
import AdDescription from "./main-info-section/AdDescription.tsx";
import AdGroupInfoSection from "./main-info-section/AdGroupInfoSection.tsx";
import AdName from "./main-info-section/AdName.tsx";
import { Price } from "./main-info-section/Price.tsx";

export const MainInfoSection: React.FC<{ id: number }> = ({ id }) => {
	return (
		<Box>
			<AdName id={id} />
			<Price id={id} />
			<AdDescription id={id} />
			<AdGroupInfoSection id={id} />
		</Box>
	);
};
